import styled from 'styled-components';
import { screen } from 'theme';

const Root = styled.div`
  background: #fbedff;
  padding: 3rem 0rem 0 0rem;

  .half {
    flex-basis: 50%;
  }

  .quarter {
    flex-basis: 33%;
  }

  .third {
    flex-basis: 33%;
  }
`;

const Content = styled.div`
  background: #dcb4e8;
  padding: 2rem 0.5rem;
  color: #52115e;
  border-radius: 15px;
  margin: 0 1rem 2rem 1rem;

  @media (min-width: ${screen('xl')}) {
    background: url('/images/companies-new/companies-new-hero-bg.svg') no-repeat
      top center;
    background-size: contain;
    border-radius: 0;
    padding: 3rem 8rem 5rem 8rem;
  }

  display: flex;
  flex-direction: column;
  gap: 1rem;

  > div:first-child p {
    font-size: 1.25rem;
  }
`;

export const YourOfferSalaryFormStyles = {
  Root,
  Content
};
